import { render, staticRenderFns } from "./Fluxos.vue?vue&type=template&id=47509edc&"
import script from "./Fluxos.vue?vue&type=script&lang=js&"
export * from "./Fluxos.vue?vue&type=script&lang=js&"
import style0 from "./Fluxos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports